import React from "react";
import { ArrowRight } from "lucide-react";
import "../styles/Enquiry.css";

const Enquiry = () => {
  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = new FormData(e.currentTarget);

    console.log(Object.fromEntries(formData.entries()));
  };

  return (
    <section className="inquiry-section">
      <div className="inquiry-card">

        <div className="inquiry-content">

          <span className="inquiry-eyebrow">
            GET CONNECTED
          </span>

          <h2>Partner With UHCS India</h2>

          <p className="inquiry-description">
            Hospitals, colleges, universities, healthcare professionals,
            training institutions, NGOs, and industry partners are invited
            to connect with UHCS for collaboration and healthcare initiatives.
          </p>

          <form className="inquiry-form" onSubmit={handleSubmit}>

            <div className="inquiry-row">

              <div className="inquiry-field">
                <label htmlFor="fullName">
                  Full Name
                </label>

                <input
                  id="fullName"
                  name="fullName"
                  type="text"
                  placeholder="Dr. / Mr. / Ms."
                  required
                />
              </div>

              <div className="inquiry-field">
                <label htmlFor="organization">
                  Institution / Organization
                </label>

                <input
                  id="organization"
                  name="organization"
                  type="text"
                  placeholder="Hospital / College / Organization"
                  required
                />
              </div>

            </div>

            <div className="inquiry-row">

              <div className="inquiry-field">
                <label htmlFor="email">
                  Email Address
                </label>

                <input
                  id="email"
                  name="email"
                  type="email"
                  placeholder="your@email.com"
                  required
                />
              </div>

              <div className="inquiry-field">
                <label htmlFor="phone">
                  Phone Number
                </label>

                <input
                  id="phone"
                  name="phone"
                  type="tel"
                  placeholder="+91 98765 43210"
                  required
                />
              </div>

            </div>

       

            <div className="inquiry-field inquiry-purpose-field">
  <label htmlFor="inquiryPurpose">
    Inquiry Purpose
  </label>

  <select
    id="inquiryPurpose"
    name="inquiryPurpose"
    defaultValue=""
    required
  >
    <option value="" disabled>
      Select inquiry purpose
    </option>

    <option value="hospital-services-jci">
      Hospital Services &amp; JCI Accreditation
    </option>

    <option value="cme-cne-training">
      CME / CNE Staff Training Program
    </option>

    <option value="government-insurance">
      Government Scheme / Insurance Claim Recovery
    </option>

    <option value="paramedical-welfare">
      Paramedical Staff Welfare &amp; Social Security
    </option>

    <option value="joint-training">
      Joint Training Initiatives
    </option>
  </select>
</div>

           

            <div className="inquiry-field inquiry-message">
              <label htmlFor="message">
                Message
              </label>

              <textarea
                id="message"
                name="message"
                rows="5"
                placeholder="Please tell us about your requirements or collaboration proposal..."
                required
              />
            </div>

            <button
              type="submit"
              className="inquiry-submit"
            >
              <span>Submit Collaboration Request</span>

              <ArrowRight size={17} strokeWidth={2} />
            </button>

          </form>

        </div>

      </div>
    </section>
  );
};

export default Enquiry;